
<div class="balance-page">

  <p-tabView
    styleClass="balance-tabs"
    [activeIndex]="activeTabIndex"
    (onChange)="onTabChange($event)"
  >

    <!-- ============================================================
         SCHEDA RESOCONTI
         ============================================================ -->

    <p-tabPanel header="Resoconti">

      <section class="balance-section">

        <div class="balance-section-header">

          <div class="balance-section-heading">
            <div class="balance-heading-icon">
              <i class="pi pi-chart-pie"></i>
            </div>

            <div class="balance-heading-text">
              <h2>Resoconti economici</h2>
              <p>
                Consulta i saldi, le entrate e le uscite dei periodi contabili.
              </p>
            </div>
          </div>

          <span class="balance-count">
            {{ balanceStatusList.length }}
            {{ balanceStatusList.length === 1 ? 'resoconto' : 'resoconti' }}
          </span>

        </div>

        <p-dataView
          #dv
          [value]="balanceStatusList"
          [loading]="balancesLoading"
          styleClass="balance-data-view"
        >

          <!-- FILTRI E AZIONI -->

          <ng-template pTemplate="header">

            <div class="balance-toolbar">

              <div class="balance-toolbar-label">
                <i class="pi pi-filter"></i>
                <span>Filtra resoconti</span>
              </div>

              <div class="balance-toolbar-controls">

                <p-autoComplete
                  placeholder="Filtra per anno"
                  [(ngModel)]="balanceFilter.years"
                  [suggestions]="filteredYear"
                  (completeMethod)="filterYear($event)"
                  [multiple]="true"
                  styleClass="balance-filter-control"
                ></p-autoComplete>

                <p-autoComplete
                  placeholder="Filtra per mese"
                  [(ngModel)]="selectedMonthsForSearch"
                  [suggestions]="filteredMonths"
                  (completeMethod)="filterMonth($event)"
                  field="month"
                  [multiple]="true"
                  styleClass="balance-filter-control"
                ></p-autoComplete>

                <p-button
                  label="Aggiorna"
                  icon="pi pi-refresh"
                  [outlined]="true"
                  [disabled]="balancesLoading"
                  (onClick)="loadAll()"
                  styleClass="balance-refresh-button"
                ></p-button>

                <p-button
                  label="Nuovo resoconto"
                  icon="pi pi-plus"
                  [disabled]="selectedBalance !== null"
                  (onClick)="createNewBalance()"
                  styleClass="balance-primary-button"
                ></p-button>

              </div>

            </div>

          </ng-template>

          <!-- SINGOLO RESOCONTO -->

          <ng-template pTemplate="listItem" let-balance>

            <div class="balance-list-item">

              <article
                class="balance-card"
                [class.balance-card-editing]="selectedBalance === balance"
              >

                <!-- INTESTAZIONE CARD -->

                <div class="balance-card-header">

                  <div class="balance-card-title">

                    <div class="balance-card-icon">
                      <i class="pi pi-calendar"></i>
                    </div>

                    <div class="balance-card-period">

                      <!-- VISUALIZZAZIONE PERIODO -->

                      <ng-container *ngIf="selectedBalance !== balance">

                        <div class="balance-year">
                          Anno {{ balance.year }}
                        </div>

                        <div class="balance-months">

                          <span
                            class="balance-month-tag"
                            *ngFor="let month of balance.monthList.split(',')"
                          >
                            {{ getMonth(month) }}
                          </span>

                        </div>

                      </ng-container>

                      <!-- MODIFICA PERIODO -->

                      <div
                        class="balance-period-edit"
                        *ngIf="selectedBalance === balance"
                      >

                        <div class="balance-edit-field">

                          <label>Anno</label>

                          <input
                            pInputText
                            type="text"
                            placeholder="Aggiungi anno"
                            [(ngModel)]="balance.year"
                          />

                        </div>

                        <div class="balance-edit-field">

                          <label>Mesi</label>

                          <p-autoComplete
                            placeholder="Aggiungi mesi"
                            [(ngModel)]="selectedMonths"
                            [suggestions]="searchedMonths"
                            (completeMethod)="searchMonth($event)"
                            field="month"
                            [multiple]="true"
                            styleClass="balance-month-selector"
                          ></p-autoComplete>

                        </div>

                      </div>

                    </div>

                  </div>

                  <span
                    class="balance-editing-badge"
                    *ngIf="selectedBalance === balance"
                  >
                    <i class="pi pi-pencil"></i>
                    In modifica
                  </span>

                </div>

                <!-- CONTENUTO CARD -->

                <div class="balance-card-body">

                  <!-- GRAFICO -->

                  <div class="balance-chart-panel">

                    <div class="balance-chart-heading">
                      <i class="pi pi-chart-pie"></i>
                      <span>Distribuzione movimenti</span>
                    </div>

                    <ng-container
                      *ngIf="
                        balance.inAmount !== 0 ||
                          balance.outAmount !== 0;
                        else noDataAvailable
                      "
                    >

                      <div class="balance-chart-wrapper">

                        <p-chart
                          type="doughnut"
                          [data]="{
                            labels: ['Entrate', 'Uscite'],
                            datasets: [
                              {
                                data: [
                                  balance.inAmount,
                                  balance.outAmount
                                ],
                                backgroundColor: [
                                  '#16a34a',
                                  '#ef4444'
                                ],
                                borderWidth: 0
                              }
                            ]
                          }"
                          [options]="{
                            responsive: true,
                            maintainAspectRatio: false,
                            cutout: '70%',
                            plugins: {
                              legend: {
                                display: false
                              }
                            }
                          }"
                        ></p-chart>

                      </div>

                      <div class="balance-chart-legend">

                        <span class="balance-legend-item">
                          <span class="balance-legend-dot income"></span>
                          Entrate
                        </span>

                        <span class="balance-legend-item">
                          <span class="balance-legend-dot expense"></span>
                          Uscite
                        </span>

                      </div>

                    </ng-container>

                    <ng-template #noDataAvailable>

                      <div class="balance-chart-empty">
                        <i class="pi pi-chart-pie"></i>
                        <span>Nessuna transazione effettuata</span>
                      </div>

                    </ng-template>

                  </div>

                  <!-- INDICATORI ECONOMICI -->

                  <div class="balance-details-panel">

                    <div class="balance-metrics-grid">

                      <!-- ==================================================
                           SALDO INIZIALE
                           SEMPRE IN SOLA LETTURA
                           ================================================== -->

                      <div class="balance-metric">

                        <div class="balance-metric-label">
                          <i class="pi pi-wallet"></i>
                          <span>Saldo iniziale</span>
                        </div>

                        <strong class="balance-metric-value">
                          {{ balance.beginAmount | currency: 'EUR' }}
                        </strong>

                      </div>

                      <!-- SALDO FINALE -->

                      <div class="balance-metric balance-metric-highlight">

                        <div class="balance-metric-label">
                          <i class="pi pi-calculator"></i>
                          <span>Saldo finale</span>
                        </div>

                        <strong class="balance-metric-value">
                          {{ balance.endAmount | currency: 'EUR' }}
                        </strong>

                      </div>

                      <!-- ENTRATE -->

                      <div class="balance-metric">

                        <div class="balance-metric-label">
                          <i class="pi pi-arrow-down-left"></i>
                          <span>Entrate</span>
                        </div>

                        <strong class="balance-metric-value income-text">
                          {{ balance.inAmount | currency: 'EUR' }}
                        </strong>

                      </div>

                      <!-- USCITE -->

                      <div class="balance-metric">

                        <div class="balance-metric-label">
                          <i class="pi pi-arrow-up-right"></i>
                          <span>Uscite</span>
                        </div>

                        <strong class="balance-metric-value expense-text">
                          {{ balance.outAmount | currency: 'EUR' }}
                        </strong>

                      </div>

                      <!-- NUMERO ENTRATE -->

                      <div class="balance-metric">

                        <div class="balance-metric-label">
                          <i class="pi pi-plus-circle"></i>
                          <span>N. entrate</span>
                        </div>

                        <strong class="balance-metric-value income-text">
                          {{ balance.inNumber }}
                        </strong>

                      </div>

                      <!-- NUMERO USCITE -->

                      <div class="balance-metric">

                        <div class="balance-metric-label">
                          <i class="pi pi-minus-circle"></i>
                          <span>N. uscite</span>
                        </div>

                        <strong class="balance-metric-value expense-text">
                          {{ balance.outNumber }}
                        </strong>

                      </div>

                    </div>

                    <!-- NOTE -->

                    <div class="balance-notes">

                      <div class="balance-notes-label">
                        <i class="pi pi-file-edit"></i>
                        <span>Note</span>
                      </div>

                      <p
                        *ngIf="selectedBalance !== balance"
                        class="balance-notes-text"
                      >
                        {{ balance.notes || 'Nessuna nota inserita.' }}
                      </p>

                      <input
                        *ngIf="selectedBalance === balance"
                        pInputText
                        type="text"
                        placeholder="Inserisci note"
                        [(ngModel)]="balance.notes"
                        class="balance-notes-input"
                      />

                    </div>

                  </div>

                </div>

                <!-- AZIONI CARD -->

                <div class="balance-card-footer">

                  <!-- VISUALIZZAZIONE -->

                  <ng-container *ngIf="selectedBalance !== balance">

                    <p-button
                      label="Modifica"
                      icon="pi pi-pencil"
                      severity="secondary"
                      [disabled]="selectedBalance !== null"
                      (onClick)="editBalance(balance)"
                      styleClass="balance-edit-button"
                    ></p-button>

                    <p-button
                      label="Elimina"
                      icon="pi pi-trash"
                      severity="danger"
                      [disabled]="selectedBalance !== null"
                      (onClick)="removeBalance(balance)"
                      styleClass="balance-delete-button"
                    ></p-button>

                  </ng-container>

                  <!-- MODIFICA -->

                  <ng-container *ngIf="selectedBalance === balance">

                    <p-button
                      label="Salva"
                      icon="pi pi-save"
                      severity="success"
                      (onClick)="modifyBalance()"
                      styleClass="balance-save-button"
                    ></p-button>

                    <p-button
                      label="Annulla"
                      icon="pi pi-times"
                      severity="secondary"
                      [outlined]="true"
                      (onClick)="deselectBalance()"
                      styleClass="balance-cancel-button"
                    ></p-button>

                  </ng-container>

                </div>

              </article>

            </div>

          </ng-template>

          <!-- NESSUN RESOCONTO -->

          <ng-template pTemplate="empty">

            <div class="balance-empty-state">

              <div class="balance-empty-icon">
                <i class="pi pi-chart-pie"></i>
              </div>

              <h3>Nessun resoconto disponibile</h3>

              <p>
                Non sono presenti resoconti per i filtri selezionati.
              </p>

            </div>

          </ng-template>

        </p-dataView>

      </section>

    </p-tabPanel>

    <!-- ============================================================
         SCHEDA TRANSAZIONI
         ============================================================ -->

    <p-tabPanel header="Transazioni">

      <section class="balance-section">

        <div class="balance-section-header">

          <div class="balance-section-heading">

            <div class="balance-heading-icon">
              <i class="pi pi-arrow-right-arrow-left"></i>
            </div>

            <div class="balance-heading-text">
              <h2>Gestione transazioni</h2>
              <p>
                Consulta e registra i movimenti economici in entrata e in uscita.
              </p>
            </div>

          </div>

          <span class="balance-count">
            {{ transactions.length }}
            {{ transactions.length === 1 ? 'transazione' : 'transazioni' }}
          </span>

        </div>

        <div class="balance-transactions-body">

          <p-table
            #dt
            [value]="paginatedTransactions"
            [loading]="transactionsLoading"
            [paginator]="false"
            [tableStyle]="{ 'min-width': '850px', 'table-layout': 'fixed', 'width': '100%' }"
            styleClass="p-datatable-sm balance-transactions-table"
          >

            <!-- FILTRI E AZIONI -->

            <ng-template pTemplate="caption">

              <div class="balance-toolbar">

                <div class="balance-toolbar-label">
                  <i class="pi pi-filter"></i>
                  <span>Filtra transazioni</span>
                </div>

                <div class="balance-toolbar-controls">

                  <p-autoComplete
                    placeholder="Filtra per anno"
                    [(ngModel)]="balanceFilter.years"
                    [suggestions]="filteredYear"
                    (completeMethod)="filterYear($event)"
                    [multiple]="true"
                    styleClass="balance-filter-control"
                  ></p-autoComplete>

                  <p-autoComplete
                    placeholder="Filtra per mese"
                    [(ngModel)]="selectedMonthsForSearch"
                    [suggestions]="filteredMonths"
                    (completeMethod)="filterMonth($event)"
                    field="month"
                    [multiple]="true"
                    styleClass="balance-filter-control"
                  ></p-autoComplete>

                  <p-button
                    label="Aggiorna"
                    icon="pi pi-refresh"
                    [outlined]="true"
                    [disabled]="transactionsLoading"
                    (onClick)="loadTransactions()"
                    styleClass="balance-refresh-button"
                  ></p-button>

                  <p-button
                    label="Nuova transazione"
                    icon="pi pi-plus"
                    [disabled]="selectedTransaction !== null"
                    (onClick)="createNewTransaction()"
                    styleClass="balance-primary-button"
                  ></p-button>

                </div>

              </div>

            </ng-template>

            <!-- INTESTAZIONE TABELLA -->

            <ng-template pTemplate="header">

              <tr>
                <th class="balance-table-actions-column">Azioni</th>
                <th class="balance-table-notes-column">Note</th>
                <th class="balance-table-amount-column">Ammontare</th>
                <th class="balance-table-date-column">Data</th>
                <th class="balance-table-category-column">Categoria</th>
              </tr>

            </ng-template>

            <!-- RIGHE TABELLA -->

            <ng-template pTemplate="body" let-transaction>

              <tr
                [class.balance-transaction-editing]="
                  selectedTransaction === transaction
                "
              >

                <!-- AZIONI -->

                <td>

                  <div class="balance-row-actions">

                    <ng-container
                      *ngIf="selectedTransaction === transaction"
                    >

                      <p-button
                        icon="pi pi-save"
                        severity="success"
                        (onClick)="modifyTransaction()"
                        styleClass="balance-table-action balance-table-save"
                        pTooltip="Salva"
                        tooltipPosition="top"
                      ></p-button>

                      <p-button
                        icon="pi pi-times"
                        severity="danger"
                        (onClick)="editTransaction(null)"
                        styleClass="balance-table-action balance-table-delete"
                        pTooltip="Annulla"
                        tooltipPosition="top"
                      ></p-button>

                    </ng-container>

                    <ng-container
                      *ngIf="selectedTransaction !== transaction"
                    >

                      <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        [disabled]="selectedTransaction !== null"
                        (onClick)="removeTransaction(transaction)"
                        styleClass="balance-table-action balance-table-delete"
                        pTooltip="Elimina"
                        tooltipPosition="top"
                      ></p-button>

                    </ng-container>

                  </div>

                </td>

                <!-- MODALITÀ MODIFICA -->

                <ng-container
                  *ngIf="selectedTransaction === transaction"
                >

                  <td>

                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="transaction.notes"
                      placeholder="Note della transazione"
                      class="balance-table-input"
                    />

                  </td>

                  <td>

                    <div class="balance-amount-editor">

                      <p-button
                        *ngIf="transaction.type === InOutType.IN"
                        icon="pi pi-plus"
                        severity="success"
                        (onClick)="transaction.type = InOutType.OUT"
                        styleClass="balance-type-button"
                        pTooltip="Entrata: clicca per cambiare"
                      ></p-button>

                      <p-button
                        *ngIf="transaction.type === InOutType.OUT"
                        icon="pi pi-minus"
                        severity="danger"
                        (onClick)="transaction.type = InOutType.IN"
                        styleClass="balance-type-button"
                        pTooltip="Uscita: clicca per cambiare"
                      ></p-button>

                      <p-inputNumber
                        locale="it-IT"
                        mode="decimal"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="2"
                        [allowEmpty]="false"
                        [(ngModel)]="transaction.amount"
                        styleClass="balance-transaction-amount-input"
                      ></p-inputNumber>

                    </div>

                  </td>

                  <td>

                    <p-calendar
                      [touchUI]="true"
                      dateFormat="yy-mm-dd"
                      [(ngModel)]="transaction.transactionDate"
                      styleClass="balance-date-picker"
                    ></p-calendar>

                  </td>

                  <td>

                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="transaction.category"
                      placeholder="Categoria"
                      class="balance-table-input"
                    />

                  </td>

                </ng-container>

                <!-- MODALITÀ VISUALIZZAZIONE -->

                <ng-container
                  *ngIf="selectedTransaction !== transaction"
                >

                  <td>

                    <span class="balance-transaction-note">
                      {{ transaction.notes || '—' }}
                    </span>

                  </td>

                  <td>

                    <span
                      class="balance-transaction-amount"
                      [ngClass]="
                        transaction.type === InOutType.IN
                          ? 'balance-transaction-income'
                          : 'balance-transaction-expense'
                      "
                    >

                      <i
                        class="pi"
                        [ngClass]="
                          transaction.type === InOutType.IN
                            ? 'pi-arrow-down-left'
                            : 'pi-arrow-up-right'
                        "
                      ></i>

                      {{ transaction.type === InOutType.IN ? '+' : '-' }}
                      {{ transaction.amount | currency: 'EUR' }}

                    </span>

                  </td>

                  <td>

                    <span class="balance-transaction-date">
                      <i class="pi pi-calendar"></i>
                      {{ transaction.transactionDate | date: 'dd/MM/yyyy' }}
                    </span>

                  </td>

                  <td>

                    <span class="balance-category-tag">
                      {{ transaction.category || 'Senza categoria' }}
                    </span>

                  </td>

                </ng-container>

              </tr>

            </ng-template>

            <!-- TABELLA VUOTA -->

            <ng-template pTemplate="emptymessage">

              <tr>

                <td colspan="5">

                  <div class="balance-empty-state">

                    <div class="balance-empty-icon">
                      <i class="pi pi-inbox"></i>
                    </div>

                    <h3>Nessuna transazione disponibile</h3>

                    <p>
                      Non sono presenti movimenti per i filtri selezionati.
                    </p>

                  </div>

                </td>

              </tr>

            </ng-template>

          </p-table>

          <div class="balance-transactions-pagination" aria-label="Paginazione transazioni">
            <button type="button" class="balance-pagination-button"
              [disabled]="transactionPage === 0 || transactionsLoading"
              (click)="previousTransactionPage()">
              <i class="pi pi-chevron-left"></i>
              <span>Precedente</span>
            </button>
            <span class="balance-pagination-counter">
              {{ transactionPageStart }}–{{ transactionPageEnd }} / {{ transactions.length }}
            </span>
            <button type="button" class="balance-pagination-button"
              [disabled]="transactionPageEnd >= transactions.length || transactionsLoading"
              (click)="nextTransactionPage()">
              <span>Successiva</span>
              <i class="pi pi-chevron-right"></i>
            </button>
          </div>

        </div>

      </section>

    </p-tabPanel>

  </p-tabView>


  <!-- Inserimento nuova transazione in dialog, senza aggiungere righe alla tabella -->
  <p-dialog
    header="Nuova transazione"
    [(visible)]="newTransactionDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="!newTransactionSaving"
    [closeOnEscape]="!newTransactionSaving"
    [dismissableMask]="false"
    [style]="{ width: 'min(94vw, 560px)' }"
    styleClass="balance-new-transaction-dialog"
    (onHide)="closeNewTransactionDialog()"
  >
    <div class="balance-dialog-form" *ngIf="newTransaction as transaction">
      <p class="balance-dialog-description">Inserisci i dati del movimento economico.</p>

      <div class="balance-dialog-field">
        <label for="new-transaction-type">Tipo di movimento</label>
        <div class="balance-dialog-type-switch" id="new-transaction-type">
          <button type="button" [class.active-income]="transaction.type === InOutType.IN"
            [attr.aria-pressed]="transaction.type === InOutType.IN"
            [disabled]="newTransactionSaving"
            (click)="transaction.type = InOutType.IN">
            <i class="pi pi-arrow-down-left"></i> Entrata
          </button>
          <button type="button" [class.active-expense]="transaction.type === InOutType.OUT"
            [attr.aria-pressed]="transaction.type === InOutType.OUT"
            [disabled]="newTransactionSaving"
            (click)="transaction.type = InOutType.OUT">
            <i class="pi pi-arrow-up-right"></i> Uscita
          </button>
        </div>
      </div>

      <div class="balance-dialog-fields-row">
        <div class="balance-dialog-field">
          <label for="new-transaction-amount">Importo (€) *</label>
          <p-inputNumber inputId="new-transaction-amount" [(ngModel)]="transaction.amount"
            locale="it-IT" mode="decimal" placeholder="0,00" [min]="0" [minFractionDigits]="2"
            [maxFractionDigits]="2" [disabled]="newTransactionSaving"
            styleClass="balance-dialog-input"></p-inputNumber>
        </div>
        <div class="balance-dialog-field">
          <label for="new-transaction-date">Data *</label>
          <div class="balance-desktop-date-picker">
            <p-calendar inputId="new-transaction-date" [(ngModel)]="transaction.transactionDate"
              dateFormat="dd/mm/yy" [showIcon]="true" [touchUI]="false"
              appendTo="body" [baseZIndex]="1200"
              [disabled]="newTransactionSaving" styleClass="balance-dialog-input"></p-calendar>
          </div>
          <input class="balance-mobile-date-picker" id="new-transaction-date-mobile"
            type="date" [ngModel]="mobileNewTransactionDate"
            (ngModelChange)="mobileNewTransactionDate = $event"
            [disabled]="newTransactionSaving" aria-label="Data della transazione" />
        </div>
      </div>

      <div class="balance-dialog-field">
        <label for="new-transaction-notes">Note *</label>
        <textarea id="new-transaction-notes" rows="3"
          [(ngModel)]="transaction.notes" [disabled]="newTransactionSaving" required
          placeholder="Descrizione della transazione"></textarea>
      </div>
      <div class="balance-dialog-field">
        <label for="new-transaction-category">Categoria</label>
        <input id="new-transaction-category" pInputText type="text"
          [(ngModel)]="transaction.category" [disabled]="newTransactionSaving"
          placeholder="Inserisci una categoria" />
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="balance-dialog-footer">
        <p-button label="Salva transazione" icon="pi pi-check"
          [loading]="newTransactionSaving"
          [disabled]="!newTransaction || !newTransaction.transactionDate || !newTransaction.amount || newTransaction.amount <= 0 || !newTransaction.notes || !newTransaction.notes.trim()"
          (onClick)="saveNewTransaction()"></p-button>
      </div>
    </ng-template>
  </p-dialog>

</div>
